module.exports = __webpack_public_path__ + "static/bag_of_holding_mtg_m20-ed0845dfd11a3b993f3cef675cd55a28.jpg";